// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4_6e9","name":"Header_name__26CRt","birthday":"Header_birthday__11RoV","skeleton":"Header_skeleton__2HKuX"};